let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6nx0x")).then(() => parcelRequire('UVBHs'));